import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CheckIcon from '@mui/icons-material/Check';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import IconButton from '@mui/material/IconButton';

import './copy-button.scss';

type Props = {
  contentToCopy: string | undefined;
};

const CopyButton = ({ contentToCopy }: Readonly<Props>): React.JSX.Element => {
  const { t } = useTranslation('copyButton');
  const [showCopiedNotice, setShowCopiedNotice] = useState(false);

  const copyContentToClipboard = async (): Promise<void> => {
    if (!contentToCopy) return;
    await navigator.clipboard.writeText(contentToCopy);
    setShowCopiedNotice(true);
    setTimeout(() => setShowCopiedNotice(false), 500);
  };

  return (
    <>
      {navigator.clipboard && contentToCopy && (
        <IconButton
          onClick={copyContentToClipboard}
          title={t('copyToClipboardButton')}
          data-testid="copy-client-secret-to-clipboard"
          className="copy-content-button"
        >
          {showCopiedNotice ? <CheckIcon /> : <ContentCopyOutlinedIcon />}
        </IconButton>
      )}
    </>
  );
};

export default CopyButton;
